export const ERROR_MESSAGE_DICT = {
    INVALID_WATCHLIST_ITEM_REMOVE: 'There was an error removing this security from your watchlist, please try again.',
    INVALID_WATCHLIST_ITEM_ADD: 'There was an error adding this security to your watchlist, please try again.',
    INVALID_WATCHLIST_ITEM_CREATE: 'There was an error creating your new watchlist, please try again.',
};
